var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnswerCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89003 0.384766L1.33537 0.609851C1.03285 0.609851 0.805957 0.909964 0.805957 1.13505C0.730326 4.9615 1.33537 8.33778 4.81439 11.7891C8.29342 15.2404 11.5455 15.6155 15.4027 15.6155C15.7052 15.6155 15.9321 15.3904 15.9321 15.0903L16.159 11.564C16.159 11.2639 15.9321 11.0388 15.7052 10.9638L12.1506 10.4386C11.9993 10.4386 11.7724 10.4386 11.6968 10.5886C10.8649 11.4139 10.2598 12.0142 10.0329 12.1642C9.65477 12.0142 8.29342 11.4139 6.7808 9.83835C5.26818 8.33778 4.51187 6.83721 4.28498 6.46207C4.5875 6.16195 5.26818 5.4867 5.87323 4.88647C6.02449 4.73641 6.02449 4.58636 6.02449 4.4363L5.49507 0.834936C5.49507 0.609851 5.19255 0.384766 4.89003 0.384766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnswerCall);
export default __webpack_public_path__ + "static/media/icon-answer-call.0a71ad19155a678d45817deef7522993.svg";
export { ForwardRef as ReactComponent };